import { apiProxyRequest } from "Api/apiProxyRequest";

import type { ActivityTypeFilters } from "./types";
import type { Activity } from "Api/activity/types";

type GetIntegrationActivitiesRequestProps = {
  projectId: string;
  encodedIntegrationId: string;
  filters?: ActivityTypeFilters | ActivityTypeFilters[];
  startsAt?: Date;
};

export const getIntegrationActivitiesRequest = ({
  projectId,
  encodedIntegrationId,
  filters,
  startsAt
}: GetIntegrationActivitiesRequestProps) =>
  apiProxyRequest<Activity[]>(
    `/projects/${projectId}/integrations/${encodedIntegrationId}/activities`,
    "GET",
    { type: filters, starts_at: startsAt?.toISOString() }
  );
